export default __webpack_public_path__ + "static/media/cif-sn.04585af7.svg";